module.exports = __webpack_public_path__ + "static/media/machine.d1f90106.png";